import router from '../../router';
const state = {
  all: []
}

const getters = {}

const actions = {
  getRoles ({ commit }) {
    axios
      .get("/admin/roles")
      .then(response => (commit('setRoles', response.data)));
  },
  addRole ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/roles", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  editRole ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/roles/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  deleteRole ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/admin/roles/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  setPermissions ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/roles/"+params.id+"/permissions", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
}

const mutations = {
  setRoles (state, data) {
    state.all = data.data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
